var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import * as React from 'react';
import classNames from 'classnames';
import { DivTag, AnchorTag, LiTag, UlTag, SpanTag, addComponentPrefix } from '../../Utils/AtomicTag';
import { ArrowDownOutlined } from '@feb-team/legao-icons-react';
var Submenu = /** @class */ (function (_super) {
    __extends(Submenu, _super);
    function Submenu(props) {
        var _this = _super.call(this, props) || this;
        _this.clickMenu = function (e, hasChildren, key, n) {
            e.stopPropagation();
            _this.props.clickMenu(hasChildren, key, !_this.props.showObj[key], false, n);
        };
        _this.mouseOverMenu = function (e, hasChildren, key, n) {
            e.stopPropagation();
            var onMouse = _this.props.onMouse;
            if (onMouse) {
                _this.props.clickMenu(hasChildren, key, true, true, n);
            }
        };
        _this.isChildrenSelect = function (children) {
            var hasSelect = false;
            children.map(function (child) {
                if (child.key === _this.props.selectedKey) {
                    hasSelect = true;
                }
                else {
                    if (child.children && child.children.length > 0) {
                        child.children.map(function (item) {
                            if (item.key === _this.props.selectedKey) {
                                hasSelect = true;
                            }
                        });
                    }
                }
            });
            return hasSelect;
        };
        _this.renderItem = function () {
            var _a, _b, _c;
            var _d = _this.props, navItem = _d.navItem, menuData = _d.menuData, menuKey = _d.menuKey, selectedKey = _d.selectedKey, level = _d.level, hasIcon = _d.hasIcon, color = _d.color, href = _d.href, target = _d.target, title = _d.title, icon = _d.icon, children = _d.children, showMini = _d.showMini, hasMini = _d.hasMini, onMouse = _d.onMouse, showObj = _d.showObj, isHorizontal = _d.isHorizontal;
            if (navItem === false) {
                return null;
            }
            else if (navItem) {
                return navItem(menuData, level);
            }
            var hasChildren = children && children.length > 0 ? true : false;
            var selectColor = children && _this.isChildrenSelect(children) ? [].concat(color) : ['text-gray-500'];
            var choseTextColor = menuKey === selectedKey ? ['text-white'] : ['text-gray-500'];
            var colorStyle = hasChildren ? selectColor : choseTextColor;
            var level3 = level == 3 ? choseTextColor : colorStyle;
            var aDefault = ['block', 'relative'];
            //  a 标签样式
            var setLinkCls = classNames((_a = {},
                _a['pl-px-48 pr-px-25 '] = level != 3 && !showMini && !isHorizontal,
                _a['pl-px-72'] = level == 3 && !onMouse,
                _a[addComponentPrefix('is-curr')] = menuKey === selectedKey && !isHorizontal,
                _a[addComponentPrefix('is-hor-curr')] = menuKey === selectedKey && isHorizontal,
                _a['h-px-40 leading-10'] = !(isHorizontal && level === 1),
                _a['h-px-64 leading-16'] = isHorizontal && level === 1,
                _a['px-4'] = (isHorizontal || showMini) && !hasChildren,
                _a['pl-4 pr-8'] = (isHorizontal || showMini) && hasChildren,
                _a));
            var autoLinkCls = setLinkCls.split(/\s/g);
            aDefault = aDefault.concat(autoLinkCls);
            var atomicCls = aDefault;
            var atomicsSpanCls = [
                hasMini && showMini && level === 1 ? 'hidden' : 'inline-block',
            ];
            // 左侧图标样式
            var setleftIconCls = classNames('absolute left-0', level3, (_b = {},
                _b['transform translate-x-6'] = true,
                _b));
            var autoleftIconCls = setleftIconCls.split(/\s/g);
            var atomicsSpanTagCls = autoleftIconCls;
            var atomicsDivTagCls = ['m-0', 'text-sm'];
            // 右侧图标
            var iconCls = [
                'absolute',
                'items-center',
                'w-px-32',
                'h-full',
                'justify-center',
                'cursor-pointer',
                'text-gray-400',
                'top-0',
                'right-0',
                'z-20',
                // 'transition',
                // 'duration-slow',
                'transform',
            ];
            var setDownCls = classNames((_c = {},
                _c['flex'] = true,
                _c[addComponentPrefix('menu-svg-rotate-0')] = showObj[menuKey] && !isHorizontal && !showMini,
                _c['-rotate-90'] = (isHorizontal && level !== 1) || showMini,
                // ['menu-svg-rotate-90']: isHorizontal && level == 1 && !showMini,
                _c['-translate-x-4'] = !isHorizontal,
                _c));
            return (React.createElement(DivTag, { atomics: atomicsDivTagCls },
                React.createElement(AnchorTag, { atomics: atomicCls, href: href ? href : 'javascript:;', target: target, autoPrefixedClassName: "menu-link" },
                    level === 1 && hasIcon && (React.createElement(SpanTag, { atomics: atomicsSpanTagCls, autoPrefixedClassName: "l-icon-x" }, typeof icon === 'string' ? React.createElement("img", { src: icon, alt: "", width: "15" }) : icon)),
                    React.createElement(SpanTag, { atomics: atomicsSpanCls, className: "" + (children && _this.isChildrenSelect(children)
                            ? [].concat(color)
                            : addComponentPrefix('menu-label')) }, title),
                    hasChildren && (!showMini || (showMini && level !== 1)) ? (React.createElement(React.Fragment, null,
                        React.createElement(SpanTag, { atomics: __spread(iconCls, [setDownCls]), className: (!isHorizontal && !showMini && addComponentPrefix('menu-header-arrow-svg')) + " " + (isHorizontal && level == 1 && addComponentPrefix('menu-header-arrow-svg')) },
                            React.createElement(ArrowDownOutlined, null)))) : null)));
        };
        return _this;
    }
    Submenu.prototype.render = function () {
        var _a, _b, _c, _d;
        var _this = this;
        var _e = this.props, level = _e.level, menuKey = _e.menuKey, children = _e.children, selectedKey = _e.selectedKey, openKeys = _e.openKeys, clickMenu = _e.clickMenu, navItem = _e.navItem, bgColor = _e.bgColor, color = _e.color, mouseMenu = _e.mouseMenu, isHorizontal = _e.isHorizontal, hasMini = _e.hasMini, showMini = _e.showMini, onMouse = _e.onMouse, onShow = _e.onShow, showObj = _e.showObj;
        var hasChildren = children && children.length > 0 ? true : false;
        var isLevel3 = level + 1 == 3 && isHorizontal && onMouse
            ? { display: 'block', marginLeft: '162px', marginTop: '-40px' }
            : { display: 'block' };
        var mini = showMini ? { display: 'block', marginLeft: '66px' } : isLevel3;
        var levelMini = level + 1 == 3 && showMini ? { display: 'block', marginLeft: '162px' } : mini;
        var openK = openKeys.indexOf(menuKey) > -1 ? levelMini : { display: 'none' };
        var isShow = (onMouse && !onShow) || (hasChildren && !showObj[menuKey] && !showMini)
            ? { display: 'none' }
            : openK;
        var setUlCls = classNames(bgColor, (_a = {},
            _a['absolute w-px-160 mt-px-2'] = isHorizontal && onMouse,
            _a['mt-px-0'] = level + 1 == 3 && onMouse,
            _a['w-px-160 absolute rounded top-0 ml-px-64'] = showMini,
            _a));
        var atomicsUlCls = setUlCls.split(/\s/g);
        var setLiCls = classNames('relative', (_b = {},
            _b['float-left'] = isHorizontal && level == 1,
            _b['w-px-240 '] = !isHorizontal && level == 1 && !showMini,
            _b));
        var atomicsLiCls = setLiCls.split(/\s/g);
        return (React.createElement(LiTag, { name: Submenu.NAME, atomics: atomicsLiCls, className: classNames((_c = {},
                _c[addComponentPrefix('is-open')] = openKeys.indexOf(menuKey) !== -1 && hasChildren,
                _c)), onClick: function (e) {
                _this.clickMenu(e, hasChildren, menuKey, '1');
            }, onMouseEnter: function (e) { return _this.mouseOverMenu(e, hasChildren, menuKey, '2'); } },
            this.renderItem(),
            level < 3 && hasChildren && (React.createElement(UlTag, { atomics: atomicsUlCls, style: isShow, className: classNames(addComponentPrefix('level') + "  " + addComponentPrefix("level-" + menuKey) + "level-" + menuKey, (_d = {},
                    _d[addComponentPrefix('bg-black-2')] = bgColor === "bg-black",
                    _d['rounded'] = hasMini || isHorizontal,
                    _d)) }, children.map(function (menu) {
                return (React.createElement(Submenu, { level: level + 1, title: menu.title, icon: menu.icon, menuKey: menu.key, bgColor: bgColor, color: color, key: menu.key, selectedKey: selectedKey, openKeys: openKeys, children: menu.children, clickMenu: clickMenu, href: menu.href, showMini: showMini, hasMini: hasMini, isHorizontal: isHorizontal, navItem: navItem, menuData: menu, mouseMenu: mouseMenu, onMouse: onMouse, onShow: onShow, showObj: showObj }));
            })))));
    };
    Submenu.NAME = 'submenu';
    return Submenu;
}(React.Component));
export { Submenu };
